let debounceTimer = null;
const SCROLL_AMOUNT = 220;

function addScrollButtons(tableEl) {
  if (tableEl.getAttribute('data-scroll-enhanced')) return;
  tableEl.setAttribute('data-scroll-enhanced', 'true');

  const wrapper = document.createElement('div');
  wrapper.className = 'table-scroll-wrapper';
  tableEl.parentNode.insertBefore(wrapper, tableEl);
  wrapper.appendChild(tableEl);

  const leftBtn = document.createElement('button');
  leftBtn.type = 'button';
  leftBtn.className = 'table-scroll-btn table-scroll-btn--left';
  leftBtn.innerHTML = '&#10094;';
  leftBtn.setAttribute('aria-label', 'Desplazar izquierda');

  const rightBtn = document.createElement('button');
  rightBtn.type = 'button';
  rightBtn.className = 'table-scroll-btn table-scroll-btn--right';
  rightBtn.innerHTML = '&#10095;';
  rightBtn.setAttribute('aria-label', 'Desplazar derecha');

  wrapper.appendChild(leftBtn);
  wrapper.appendChild(rightBtn);

  leftBtn.addEventListener('click', () => {
    tableEl.scrollBy({ left: -SCROLL_AMOUNT, behavior: 'smooth' });
  });
  rightBtn.addEventListener('click', () => {
    tableEl.scrollBy({ left: SCROLL_AMOUNT, behavior: 'smooth' });
  });

  // Muestra u oculta los botones según si hay contenido lateral
  const updateHorizontal = () => {
    const canLeft  = tableEl.scrollLeft > 0;
    const canRight = tableEl.scrollLeft < tableEl.scrollWidth - tableEl.clientWidth - 1;

    leftBtn.style.opacity       = canLeft  ? '1' : '0';
    leftBtn.style.pointerEvents = canLeft  ? 'auto' : 'none';
    rightBtn.style.opacity      = canRight ? '1' : '0';
    rightBtn.style.pointerEvents = canRight ? 'auto' : 'none';
  };

  // Mantiene el botón centrado en la porción visible de la tabla
  const updateVertical = () => {
    const rect = wrapper.getBoundingClientRect();
    const vh   = window.innerHeight;

    // Porción visible de la tabla (en coordenadas relativas al wrapper)
    const visTop    = Math.max(0, -rect.top);
    const visBottom = Math.min(rect.height, vh - rect.top);

    if (visBottom <= visTop) return;

    const center = visTop + (visBottom - visTop) / 2;
    leftBtn.style.top  = `${center}px`;
    rightBtn.style.top = `${center}px`;
  };

  const onScroll = () => { updateHorizontal(); updateVertical(); };

  tableEl.addEventListener('scroll', onScroll);
  window.addEventListener('scroll', updateVertical, { passive: true });

  const resizeObserver = new ResizeObserver(() => { updateHorizontal(); updateVertical(); });
  resizeObserver.observe(wrapper);

  updateHorizontal();
  updateVertical();
}

function runEnhancement() {
  document
    .querySelectorAll('.table-responsive:not([data-scroll-enhanced])')
    .forEach(addScrollButtons);
}

export function initTableScrollObserver() {
  runEnhancement();

  const observer = new MutationObserver(() => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(runEnhancement, 250);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  return () => {
    observer.disconnect();
    clearTimeout(debounceTimer);
  };
}
